import React, { useContext, useState } from "react";
import cn from "classnames";

import "./PasswordForm.scss";


import Eye from "../../images/eye.svg";
import EyeOff from "../../images/eye-off.svg";

import ButtonSubmit from "../ButtonSubmit";
import InputGlobal from "../InputGlobal";
import Tooltip from "../Tooltip";
import ProgressDots from "../ProgressDots/ProgressDots";

import { ContextProfileUser } from "../../lib/profileContext";
import { apiRegistration } from "../../services/api";

import { useAppendLandingId } from "../../hooks/useAppendLandingId";
import { errorEventsPassword, landingId } from "../../constants";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  validatePassword,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";

function PasswordForm() {

  const { data, setData } = useContext(ContextProfileUser);

  const [passwordShow, setPasswordShow] = useState(false);
  const [checkBox, setCheckBox] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const [errors, setErrors] = useState({
    password: null,
    terms: null,
    response: null,
  });

  useAppendLandingId(landingId);

  const toggleBtn = (e) => {
    e.preventDefault();
    setPasswordShow(!passwordShow);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors((prev) => ({ ...prev, response: null }));

    const { status, error = { text: "", type: "" } } = validatePassword(
      data.password
    );

    let hasError = false;

    if (error.type) {
      simplyClick(errorEventsPassword[error.type]);
    }

    if (!status) {
      setErrors((prev) => ({ ...prev, password: error.text }));
      hasError = true;
    } else {
      setErrors((prev) => ({ ...prev, password: null }));
    }

    if (!checkBox) {
      simplyClick("err_lnd_checkbox_nocheckbox");
      setErrors((prev) => ({ ...prev, terms: true }));
      hasError = true;
    } else {
      setErrors((prev) => ({ ...prev, terms: null }));
    }

    if (hasError) {
      return;
    }

    setLoader(true);
    apiRegistration(prepareRegistrationData(data), responseCb);
    simplyClick("cl_lnd_password_join");

  };

  const responseCb = (response) => {
    setLoader(false);

    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);
        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed === REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }
      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);
      if (data.errors && data.errors.length > 0) {
        let errorText = data.errors.map((e) => e.message).join(" ");
        setErrors((prev) => ({ ...prev, response: errorText }));
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setErrors((prev) => ({
      ...prev,
      response: "Can't register your profile now. Please try again later.",
    }));
  };

  const handleAddPassword = ({ target: { value } }) => {
    setErrors((prev) => ({ ...prev, password: null }));
    setShowTooltip(false);
    setData({ ...data, password: value });
  };

  const handleCheckBox = (e) => {
    setErrors((prev) => ({ ...prev, terms: null }));
    setCheckBox(!checkBox);
    simplyClick("cl_lnd_password_checkbox");
  };

  return (
    <div className="error__form-wrapper">
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}

      <div className="user__form-top">
        <h3>My password</h3>
      </div>
      <form
        className="password__form"
        onSubmit={handleSubmit}
        autoComplete="on"
      >
        <div className="input__password-wrapper">
          <InputGlobal
            onChange={(e) => handleAddPassword(e)}
            placeholder={"Enter your password"}
            className={cn("input__global", "input__password", {
              input__error: errors.password,
            })}
            name="password"
            type={passwordShow ? "text" : "password"}
            autoComplete="new-password"
            value={data.password || ""}
            onFocus={() => {
              if (!data.password || data.password.trim() === "") {
                setShowTooltip(true);
              } else {
                setShowTooltip(false);
              }
              simplyClick("cl_lnd_password_type_pass");
            }}
            onBlur={() => setShowTooltip(false)}
          />
          <button onClick={toggleBtn} className="logo__eye">
            {passwordShow ? (
              <img src={Eye} alt="icon" />
            ) : (
              <img src={EyeOff} alt="icon" />
            )}
          </button>
          <Tooltip
            text="Your password must be at least 5 characters long. You can recover it using the email you provided."
            showTooltip={showTooltip}
            className="password"
          />
        </div>
        {errors.password && <p className="errorPassword">{errors.password}</p>}
        <div className="form-group">
          <input
            checked={checkBox}
            onChange={(e) => handleCheckBox(e)}
            type="checkbox"
            id="remember_me"
            className={cn("checkBox", {
              checkBox__error: errors.terms,
            })}
            name="remember"
            value="1"
          />
          <div className="checkbox-text">
            <span>
              I have read, understand and agree to
              <br />
              <a href="/terms-of-use/" target="_blank">
                Terms of Use,
              </a>
              &nbsp;
              <a href="/privacy-policy/" target="_blank">
                Privacy Policy,
              </a>
              &nbsp;
              <a href="/cookie-policy/" target="_blank">
                Cookie Policy,
              </a>
              &nbsp;
              <a href="/billing-policy/" target="_blank">
                Billing
              </a>
              &nbsp;
              <span className="puprle_span">&</span>
              &nbsp;
              <a href="/refund-policy/" target="_blank">
                Refund Policy,
              </a>
              &nbsp;
              <a href="/consent-policy/" target="_blank">
                Consent Policy
              </a>
            </span>
          </div>
        </div>
        {errors.terms && (
          <p className="errorPasswordCheck">
            Please accept our Terms of Use, Privacy Policy, Cookie Policy,
            Billing & Refund Policy, Consent Policy
          </p>
        )}
        {errors.response && <p className="errorPassword">{errors.response}</p>}
        <ButtonSubmit
          className={"button__global button__password"}
          text={"JOIN NOW"}
        />
        <ProgressDots total={6} activeCount={6} />
      </form>
    </div>
  );
}

export default PasswordForm;
